import React from "react";
import {inject, observer} from "mobx-react";
import {
    Grid,
    Switch, 
} from "@material-ui/core";
import Scroll from '../../../components/InfiniteScroll/Scroll';

import {withStyles} from "@material-ui/core/styles/index";

import {
    findAllAgendamentoTipoPage,
    findByIdAgendamentoTipo,
    saveAgendamentoTipo,
    findAllTuss52TerminologiaTipoConsulta,
    findAllTuss22ProcedimentoEventoSaude,
    agendamentoTipoNomeJaExistente,
    findProfissionaisByAgendamentoTipo,
    vincularProfissionaisComValorByAgendamentoTipo,
} from '../../../services/AgendamentoTipoService';
import Notification from "../../../components/Notification";
import { getUnidadeLogado } from "../../../services/UsuarioService";
import { findAllLigacaoConvenio, listarConveniosTipoConsulta } from "../../../services/ConvenioService";
import string from "../../../utils/string";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { pageConfiguracoes } from "../../../utils/getPageTitle";
import { tabs } from "../../../stores/ModalConfiguracoes.store";
import { findAllAgendamentoTipoAuditByAgendamentoTipoId, findAllAgendamentoTipoAuditByUnidade } from "../../../services/AuditoriaService";
import HeaderConfiguracoesButtonNovo from "../Components/HeaderConfiguracoesButtonNovo";
import ContentConfiguracoes from "../Components/ContentConfiguracoes";
import Table from "../../../components/Table/Table";
import { columnsConfiguracoes } from "../Constants/Constants";
import AddIcon from "../../../components/Icon/AddIcon";
import ModalConfiguracoesTabs from "../Components/Modal/ModalConfiguracoesTabs";
import ConvenioList from "../Components/Modal/Tabs/ConvenioList";
import ProfissionalSaudeValorList from "../Components/Modal/Tabs/ProfissionalSaudeValorList";
import ModalConfirmacao from "../../../components/Modal/ModalConfirmacao/ModalConfirmacao";
import WarningIcon from "../../../components/Icon/Warning";
import { TextField, TextFieldSearch } from '../../../components/TextField'
import { Add } from "@material-ui/icons";
import { Button } from "../../../components/ui/Buttons";
import InputForm from "../../../components/Input/InputForm";
import { optionsMotivoCancelamento } from "../Components/Modal/Constants";

@inject(
    'sujeitoAtencaoStore',
    'atendimentoStore',
    'filtroHeaderStore',
    'agendamentoTipoStore',
    'googleAnalyticsStore',
    "usuarioStore",
    "modalConfiguracoesStore",
    "auditoriaStore",
    'unidadeStore'
)
@observer
class ConfiguracaoConsulta extends React.Component {
    state = {
        isLoading: false,
        agendamentoTipo: [],
        agendamentoTipoSelected: undefined,
        keyAgendamentoTipo: 0,
        loadingSave: false,
        modificacoesPage: 0,
        lastPage: false,
        sortField: 'descricao',
        sortDir: 'ASC',
        convenios: [],
        profissionais: [],
        pageNumberModal: 0,
        pageNumberProfissionais: 0,
        lastModal: false,
        lastProfissionais: false,
        loadingModal: false,
        loadingProfissionais: false,
        disableButton: false,
        listaModal: [],
        tabSelected: tabs.INFORMACOES,
        tabSelectedModal: 0,
        search: "",
        status: true,
        propsTabsModal: {
            valueSearch: "",
        },
        openAlertAgendamentoTipo: false,
        propsTabsAuditoria: {
            tabSelected: tabs.INFORMACOES
        },
        ordenarTabela: {
            sortField: "descricao",
            sortDir: "ASC",
        },
        utilizaDuracaoProcedimentosTipoConsulta:null
    };

    async componentDidMount() {
        const { modalConfiguracoesStore } = this.props;
        this.loadAgendamentoTipo();
        this.getConfiguracaoUnidade()

        const paginaVisualizada = {
            page: window.location.hash, 
            title: 'Configurações - Configuração de Consulta'
        }
        this.props.googleAnalyticsStore.pageView(paginaVisualizada);

        modalConfiguracoesStore.titulo="consulta";
    }

    getConfiguracaoUnidade = async() => {
        const { unidadeStore } = this.props;

        await unidadeStore.inicializaConfiguracaoUnidade();

        const { configuracaoUnidade } = unidadeStore || {};
        this.setState({ utilizaDuracaoProcedimentosTipoConsulta: !!configuracaoUnidade?.utilizaDuracaoProcedimentosTipoConsulta })
    }

    setAuditoriaTela = () => {
        const { auditoriaStore } = this.props;

        auditoriaStore.auditoriaProps={
            ...auditoriaStore.auditoriaProps,
            auditoria: "o tipo consulta",
            auditoriaTela: "agendamentoTipo",
        };

        auditoriaStore.load={
            query: findAllAgendamentoTipoAuditByUnidade, 
            variableName: "",
            variableId: "", 
        };
    };

    loadConvenios = async() => {
        const { propsTabsModal, pageNumberModal, agendamentoTipoSelected } = this.state;
        this.setState({ loadingModal: true });
        
        try {
            const response = await findAllLigacaoConvenio({
                search: propsTabsModal.valueSearch,
                pageableDto: {
                    pageNumber: pageNumberModal,
                    pageSize: 10,
                    sortDir: "ASC",
                    sortField: "descricao"
                },
                entidadeId: agendamentoTipoSelected?.id ? String(agendamentoTipoSelected.id) : null,
                tipoLigacaoEntidadesValores: "AGENDAMENTO_TIPO"
            });

            const { content, last } = response || {};

            const convenios = content.map(convenioItem => {
                const convenioChecked = agendamentoTipoSelected?.convenioAgendamentoTipo?.find(item => item.convenio?.id === Number(convenioItem.id)) || false;
                const valorNumber = convenioChecked?.valor || 0;

                return {
                    convenio: {
                        descricao: convenioItem.descricao,
                        id: convenioItem.id,
                        checked: !!convenioChecked,
                    },
                    valor: typeof convenioChecked?.valor === "number" ? String(valorNumber.toFixed(2).replace('.', ',')) : valorNumber
                }
            });

            this.setState({
                convenios: [...this.state.convenios, ...convenios],
                lastModal: last
            })

        } catch(e) {
            console.error('error', e)

        } finally {
            this.setState({ loadingModal: false })
        }
       
        await listarConveniosTipoConsulta({
            search: propsTabsModal.valueSearch,
            pageNumber: pageNumberModal
        })
            .then(({ data: response }) => {

            })
            .finally(() => {
                this.setState({ loadingModal: false })
            })
    }

    loadProfissionais = async() => {
        const { propsTabsModal, pageNumberProfissionais, agendamentoTipoSelected } = this.state;
        this.setState({ loadingProfissionais: true });

        try {
            const response = await findProfissionaisByAgendamentoTipo({
                search: propsTabsModal.valueSearch || null,
                pageableDto: {
                    pageNumber: pageNumberProfissionais,
                    pageSize: 10,
                    sortDir: "ASC",
                    sortField: "descricao"
                },
                entidadeId: String(agendamentoTipoSelected?.id),
            });

            const { content, last } = response || {};

            const profissionais = (content || []).map(item => {
                const hasValor = item.valor !== null && item.valor !== undefined;
                return {
                    profissionalSaude: {
                        nome: item.descricao,
                        id: item.id,
                        checked: hasValor,
                    },
                    valor: hasValor ? String(Number(item.valor).toFixed(2).replace('.', ',')) : 0,
                };
            });

            this.setState({
                profissionais: [...this.state.profissionais, ...profissionais],
                lastProfissionais: last,
            });
        } catch(e) {
            console.error('error loadProfissionais', e);
        } finally {
            this.setState({ loadingProfissionais: false });
        }
    }

    loadMoreProfissionais = () => {
        const { pageNumberProfissionais, lastProfissionais } = this.state;
        if (lastProfissionais) return;
        this.setState({ pageNumberProfissionais: pageNumberProfissionais + 1 }, () => {
            this.loadProfissionais();
        });
    }

    handleChangeCheckboxProfissional = (itemLista, index) => {
        const { profissionais } = this.state;
        const updatedList = [...profissionais];
        updatedList[index] = {
            ...updatedList[index],
            profissionalSaude: {
                ...updatedList[index].profissionalSaude,
                checked: !updatedList[index].profissionalSaude.checked,
            },
        };
        this.setState({ profissionais: updatedList });
    }

    handleChangeProfissionalValor = (e, itemLista, index) => {
        const { profissionais } = this.state;
        const updatedList = [...profissionais];
        updatedList[index] = {
            ...updatedList[index],
            valor: e.target.value,
        };
        this.setState({ profissionais: updatedList });
    }

    loadAgendamentoTipo = (options) => {
        if(options?.resetSearch){
            this.setState({
                modificacoesPage: 0
            })
        }
        const pageableDTO = {
            pageNumber: options?.resetSearch ? 0 : this.state.modificacoesPage,
            pageSize: 30,
            sortDir: options?.sortDir || this.state.sortDir,
            sortField: options?.sortField || this.state.sortField,
        }

        const nextPage = options?.resetSearch ? 1 : this.state.modificacoesPage + 1
        
        this.setState({isLoading: true});
        findAllAgendamentoTipoPage(pageableDTO, this.state.search, this.state.status)
            .then(({data: response}) => {
                const {content, last} = response.data.findAllAgendamentoTipoPage
                this.setState({
                    agendamentoTipo: 
                    options?.resetSearch ? content : [...this.state.agendamentoTipo, ...content],
                    lastPage: last,
                    modificacoesPage: nextPage,
                });
            })
            .catch(() => {
                this.props.agendamentoTipoStore.openNotification(
                    "Falha ao carregar lista com os tipos de atendimentos.",
                    "error"
                );
            })
            .finally(() => {
                this.setState({isLoading: false});
            });
    }

    handleDuplicar = async (id) => {
        this.editAgendamentoTipoById(id, true);
    }

    handleAtivar = async (id) => {
        const { modalConfiguracoesStore } = this.props;
        const response = await findByIdAgendamentoTipo(id);
        const selecionado = response.data.data.findByIdAgendamentoTipo;
        const selecionadoComId = {
            ...selecionado,
            id,
            ativo: true
        }

        delete selecionadoComId.tuss52TerminologiaTipoConsulta?.codigoTermoDescricao;
        delete selecionadoComId.tuss22ProcedimentoEventoSaude?.codigoTermoDescricao;
        await saveAgendamentoTipo(selecionadoComId);
        this.setState({
            agendamentoTipo: [],
            pageNumber: 0
        });
        modalConfiguracoesStore.showModal=false;
        this.loadAgendamentoTipo({ resetSearch: true });
    };

    handleInativar = async (id) => {
        const { modalConfiguracoesStore } = this.props;
        const response = await findByIdAgendamentoTipo(id);
        const selecionado = response.data.data.findByIdAgendamentoTipo;
        const selecionadoComId = {
            ...selecionado,
            id,
            ativo: false
        }
        delete selecionadoComId.tuss52TerminologiaTipoConsulta?.codigoTermoDescricao;
        delete selecionadoComId.tuss22ProcedimentoEventoSaude?.codigoTermoDescricao;
        await saveAgendamentoTipo(selecionadoComId);
        this.setState({
            agendamentoTipo: [],
            pageNumber: 0
        });
        modalConfiguracoesStore.showModal=false;
        this.loadAgendamentoTipo({ resetSearch: true });
    };

    handleClickRow = (id) => {
        this.editAgendamentoTipoById(id);
    };

    editAgendamentoTipoById = (id, isDuplicar=false) => {
        const { modalConfiguracoesStore } = this.props;
        this.setState({isLoading: false});
        
        findByIdAgendamentoTipo(id)
            .then(({data: response}) => {
                const agendamentoSelected = response.data.findByIdAgendamentoTipo;
                if (isDuplicar) {
                    agendamentoSelected.id=null;
                    agendamentoSelected.descricao=`${agendamentoSelected.descricao} - cópia`;
                };

                this.setState({
                    agendamentoTipoSelected: agendamentoSelected,
                }, () => { 
                    modalConfiguracoesStore.showModal = true;
                    this.loadConvenios() 
                })
            })
            .catch(() => {
                this.props.agendamentoTipoStore.openNotification(
                    "Falha ao carregar o tipo de atendimento.",
                    "error"
                );
            })
            .finally(() => {
                this.setState({isLoading: false})
            });
    };

    save = async({isSaveMesmoNome=false}) => {
        this.setState({loadingSave: true});
        const { agendamentoTipoStore } = this.props;
        try {
            const { agendamentoTipoSelected } = this.state;
            if(!agendamentoTipoSelected.descricao || string.isEmpty(agendamentoTipoSelected.descricao)) {
                agendamentoTipoStore.openNotification(
                    "Digite o nome do atendimento",
                    "error"
                );
                return
            }

            const existeMesmoNome = await this.verificaAgendamentoTipoComMesmoNome(agendamentoTipoSelected.descricao)

            if(!isSaveMesmoNome && existeMesmoNome) return;

            const listaAgendamentoTipo = agendamentoTipoSelected.convenioAgendamentoTipo.map(item => {
                const valorNumber = typeof item.valor === 'string' ?  string.currencyMaskToFloat(item.valor) : item.valor;
                
                return({
                    ...item,
                    motivoCancelamentoTipo: item.motivoCancelamentoTipo?.value,
                    valor: valorNumber
                })
            })
            
            const agendamentoTipo = {
                ...agendamentoTipoSelected,
                duracaoTipoConsulta: agendamentoTipoSelected.duracaoTipoConsulta || null,
                descricao: agendamentoTipoSelected.descricao || agendamentoTipoSelected.nome,
                convenioAgendamentoTipo: listaAgendamentoTipo,
            }
            delete agendamentoTipo.nome 
            if(agendamentoTipo.descricao.toUpperCase() === "CONSULTA") {
                this.props.agendamentoTipoStore.openNotification(
                    "Já existe o agendamento do tipo Consulta.",
                    "warning"
                );
                this.setState({loadingSave: false});
                return
            }

            delete agendamentoTipo.tuss52TerminologiaTipoConsulta?.codigoTermoDescricao;
            delete agendamentoTipo.tuss22ProcedimentoEventoSaude?.codigoTermoDescricao;

            await saveAgendamentoTipo(agendamentoTipo);

            // Salvar vínculos de profissionais com valor
            const profissionaisChecked = this.state.profissionais
                .filter(item => item.profissionalSaude?.checked)
                .map(item => ({
                    profissionalSaudeId: Number(item.profissionalSaude.id),
                    valor: typeof item.valor === 'string' ? string.currencyMaskToFloat(item.valor) : item.valor,
                }));

            if (agendamentoTipo.id && profissionaisChecked.length > 0) {
                await vincularProfissionaisComValorByAgendamentoTipo({
                    agendamentoTipoId: agendamentoTipo.id,
                    itens: profissionaisChecked,
                });
            }

            const { modalConfiguracoesStore } = this.props;

            modalConfiguracoesStore.showModal = false;
            this.setState({
                agendamentoTipoSelected: undefined,
                convenios: [],
                pageNumberModal: 0,
                propsTabsModal: {
                    valueSearch: "",
                },
            }, () => {
                this.loadAgendamentoTipo({resetSearch: true});
            });

        } catch (e) {
            agendamentoTipoStore.openNotification(
                "Erro ao salvar o tipo de atendimento",
                "error"
            );
        } finally {
            this.setState({loadingSave: false});
        }
    }

    createAgendamentoTipo = async() => {
        const { modalConfiguracoesStore } = this.props;

        const unidade = await getUnidadeLogado();
        this.setState({
            agendamentoTipoSelected: {
                unidade: {id: unidade.id},
                ativo: true,
                convenioAgendamentoTipo: [],
                geraFinanceiro: true,
            }
        }, () => {
            modalConfiguracoesStore.showModal = true;
            this.loadConvenios();
        });
    }

    handleClickOrdenar = async (value) => {
        const { ordenarTabela } = this.state;
        
        const sortDir =
        ordenarTabela.sortField !== value
            ? "ASC"
            : ordenarTabela.sortDir === "ASC"
                ? "DESC"
                : "ASC";

        const status = value === 'ativo' ? sortDir === 'ASC' : this.state.status;

        this.setState({            
            ordenarTabela: { 
              sortDir: sortDir,
              sortField: value,
            },
            status,
            agendamentoTipo: [],
            pageNumber: 0
        }, () => this.loadAgendamentoTipo({resetSearch: true, sortField: value, sortDir}));
    }

    onCloseModalTipoAgendamento = () => {
        const { modalConfiguracoesStore } = this.props;

        modalConfiguracoesStore.showModal = false;
        this.setState({
            agendamentoTipoSelected: undefined,
            convenios: [],
            pageNumberModal: 0,
            propsTabsModal: {
                valueSearch: "",
            },
        });
        this.setState({agendamentoTipoSelected: undefined});
    }

    handleClose = (reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.props.agendamentoTipoStore.closeNotification();
    };

    handleClickSearchModal = () => {
        const { tabSelectedModal } = this.state;
        if (tabSelectedModal === 1) {
            this.setState({ profissionais: [], pageNumberProfissionais: 0 }, () => this.loadProfissionais());
        } else {
            this.setState({ convenios: [], pageNumberModal: 0 }, () => this.loadConvenios());
        }
    };

    onChangeSearchModal = (e) => {
        const { propsTabsModal } = this.state;

        let value = e.target.value;
        this.setState({ propsTabsModal: {
            ...propsTabsModal,
            valueSearch: value
        } })
    };

    handleClickClearModal = () => {
        const { tabSelectedModal } = this.state;
        if (tabSelectedModal === 1) {
            this.setState({ propsTabsModal: { valueSearch: "" }, profissionais: [], pageNumberProfissionais: 0 }, () => this.loadProfissionais());
        } else {
            this.setState({ propsTabsModal: { valueSearch: "" }, convenios: [], pageNumberModal: 0 }, () => this.loadConvenios());
        }
    };

    onKeypressSearchModal = (e) => {
        const { propsTabsModal, tabSelectedModal } = this.state;

        if (e.key === 'Enter' && propsTabsModal.valueSearch.length >= 3) {
            if (tabSelectedModal === 1) {
                this.setState({ profissionais: [], pageNumberProfissionais: 0 }, () => this.loadProfissionais());
            } else {
                this.setState({ convenios: [], pageNumberModal: 0 }, () => this.loadConvenios());
            }
        };
    };

    loadMoreModal = () => {
        const { loadingModal, convenios, pageNumberModal } = this.state;
        if (loadingModal) {
            return;
        }

        this.setState({ pageNumberModal: convenios.length > 0 ? pageNumberModal + 1 : 0 });

        this.loadConvenios();
    };

    handleChangeCheckbox = (item) => {
        item.convenio.checked = !item.convenio.checked;
        let object = this.state.agendamentoTipoSelected;

        if (item.convenio.checked) {
            object.convenioAgendamentoTipo.push({
                convenio: {
                    id: item.convenio.id
                },
                valor: item.valor
            });

        } else {
            const array = object.convenioAgendamentoTipo.filter(convenioItem => convenioItem.convenio.id !== item.convenio.id);
            object.convenioAgendamentoTipo = array;
        }

        this.setState({ agendamentoTipoSelected: object })

    };

    handleChange = (event, itemLista) => {
        const { name, value } = event.target;
        const { agendamentoTipoSelected } = this.state;

        if (itemLista) {
            itemLista.valor = value;
            const indexSelecionado = agendamentoTipoSelected.convenioAgendamentoTipo.findIndex(item => item.convenio.id === Number(itemLista.convenio.id));
            if (indexSelecionado >= 0) {
                let object = agendamentoTipoSelected;
                object.convenioAgendamentoTipo[indexSelecionado].valor = itemLista.valor;
                this.setState({agendamentoTipoSelected: object});
            }
            
        } else {
            this.setState(prevState => ({
                agendamentoTipoSelected: {
                    ...prevState.agendamentoTipoSelected,
                    [name]: value
                },
            }));
        }
    };

    handleChangeMotivoCancelamento = (value, itemLista) => {
        const { agendamentoTipoSelected } = this.state;

        if (itemLista) {
            itemLista.motivoCancelamentoTipo = value;
            const indexSelecionado = agendamentoTipoSelected.convenioAgendamentoTipo.findIndex(item => item.convenio.id === itemLista.convenio.id);
            if (indexSelecionado >= 0) {
                let object = agendamentoTipoSelected;
                object.convenioAgendamentoTipo[indexSelecionado].motivoCancelamentoTipo = itemLista.motivoCancelamentoTipo;
                this.setState({agendamentoTipoSelected: object});
            }
            
        } else {
            this.setState(prevState => ({
                agendamentoTipoSelected: {
                    ...prevState.agendamentoTipoSelected,
                    motivoCancelamentoTipo: value
                },
            }));
        }
    };

    handleChangeTipoConsulta = (option, field) => {
        this.setState({
            agendamentoTipoSelected:{
                ...this.state.agendamentoTipoSelected,
                [field]: option,
            }
        })
    };

    changeTabSelected = async(tabSelected) => {
        const { auditoriaStore } = this.props;
        const { agendamentoTipoSelected } = this.state;

        auditoriaStore.auditoriaProps={
          ...auditoriaStore.auditoriaProps,
          pageNumber: 0,
          lastPage: false,
          auditorias: [],
        }

        if(tabSelected === 1) {
            auditoriaStore.load={
                query: findAllAgendamentoTipoAuditByAgendamentoTipoId, 
                variableName: "agendamentoTipoId",
                variableId: agendamentoTipoSelected.id, 
            }
            await auditoriaStore.loadAuditItems();
        }

        this.setState({ tabSelected })
    };

    handleClickSearch = () => {
        this.setState({
            convenios: [],
            pageNumber: 0
        }, () => {
            this.loadAgendamentoTipo({resetSearch: true});
        });
        
    };

    handleClickClear = () => {
        this.setState({
            search: "",
            convenios: [],
            pageNumber: 0,
        }, () => {
            this.loadAgendamentoTipo({resetSearch: true});
        });
        
    };

    onChangeSearch = (e) => {
        let search = e.target.value;
        this.setState({ search })
    };

    onKeypressSearch = (e) => {
        if (e.key === 'Enter' && this.state.search.length >= 3) {
            this.setState({
                convenios: [],
                pageNumber: 0,
            }, () => {
                this.loadAgendamentoTipo({resetSearch: true});
            });
        }
    };

    setAuditoriaModal = () => {
        const { auditoriaStore } = this.props;
        const { agendamentoTipoSelected } = this.state;

        auditoriaStore.auditoriaProps={
            ...auditoriaStore.auditoriaProps,
            auditoria: "o tipo consulta",
            auditoriaTela: "agendamentoTipo",
        };

        auditoriaStore.load={
            query: findAllAgendamentoTipoAuditByAgendamentoTipoId, 
            variableName: "agendamentoTipoId",
            variableId: agendamentoTipoSelected.id,
        }
    };

    changeTabModalAuditoriaSelected = async(tabSelected) => {
        const { auditoriaStore } = this.props;
        const { agendamentoTipoSelected } = this.state;

        auditoriaStore.auditoriaProps={
            ...auditoriaStore.auditoriaProps,
            pageNumber: 0,
            lastPage: false,
            auditorias: [],
        };

        if (tabSelected === 1) {
            auditoriaStore.auditoriaProps={
                ...auditoriaStore.auditoriaProps,
                auditoria: "o tipo de consulta",
                auditoriaTela: "agendamentoTipo",
            };    

            auditoriaStore.load={
                query: findAllAgendamentoTipoAuditByAgendamentoTipoId, 
                variableName: "agendamentoTipoId",
                variableId: agendamentoTipoSelected.id,
            }
            await auditoriaStore.loadAuditItems();
          }

        this.setState({
            propsTabsAuditoria: {
                tabSelected: tabSelected
            }
        })
    };

    saveAgendamentoTipoComMesmoNome = () => {
        const { agendamentoTipoSelected } = this.state;

        this.setState({
            agendamentoTipoSelected: {
                ...agendamentoTipoSelected,
                descricao: `${agendamentoTipoSelected.descricao} - cópia`
            }
        }, () => {
            this.closeModalConfirmacao();
            this.save({isSaveMesmoNome: true});
        });
    };

    closeModalConfirmacao = () => {
        this.setState({ openAlertAgendamentoTipo: false })
    }

    voltarMudarNome = () => {
        const { modalConfiguracoesStore } = this.props;
        this.closeModalConfirmacao();
        modalConfiguracoesStore.showModal=true;
    };

    verificaAgendamentoTipoComMesmoNome = async(nomeAgendamentoTipo) => {
        const { agendamentoTipoSelected } = this.state;
        const existeMesmoNome = await agendamentoTipoNomeJaExistente(nomeAgendamentoTipo);
        this.setState({ 
            openAlertAgendamentoTipo: existeMesmoNome && !agendamentoTipoSelected.id,
        })

        return existeMesmoNome && !agendamentoTipoSelected.id;
    };

    loadAllTuss52 = async (search, loadedOptions, { page }) => {
        const pageableDTO = {
          pageNumber: page,
          pageSize: 10,
          sortDir: "ASC",
          sortField: "codigoTermo",
        };
        try {
          const { content, last } = (await findAllTuss52TerminologiaTipoConsulta(
            pageableDTO,
            true,
            search
          )).data.data.findAllTuss52TerminologiaTipoConsulta;
          return {
            options: content,
            hasMore: !last,
            additional: {
              page: page + 1,
            },
          };
        } catch {
          this.openNotification(
            "Erro ao carregar Tuss 52 - Tipos de consultas",
            "error"
          );
        }
      };

      loadAllTuss22 = async (search, loadedOptions, { page }) => {
        const pageableDTO = {
          pageNumber: page,
          pageSize: 10,
          sortDir: "ASC",
          sortField: "codigoTermo",
        };
        const searchDTO = {
          pageableDTO,
          search,
        };
    
        try {
          const { content, last } = (await findAllTuss22ProcedimentoEventoSaude(
            searchDTO
          )).data.data.findAllTuss22ProcedimentoEventoSaude;
          return {
            options: content,
            hasMore: !last,
            additional: {
              page: page + 1,
            },
          };
        } catch {
          this.openNotification(
            "Erro ao carregar Tuss 22 - Procedimentos e eventos em saúde ",
            "error"
          );
        }
      };

    renderHeader = () => {
        const { classes } = this.props;
        const { agendamentoTipoSelected ,utilizaDuracaoProcedimentosTipoConsulta} = this.state;
        const unidadeLogada = JSON.parse(localStorage['_immortal|unidadeLogada']);

        return(
            <>
                <div className={classes.rowNome}>
                    <div className={classes.contentNome}>
                        <div className={classes.titleRenderHeader}>
                            Nome do tipo atendimento *Obrigatório
                        </div>
                        <TextField
                            id='cfg-cco-inp-nom'
                            name={"descricao"}
                            className={classes.textField}
                            classes={{
                            root: classes.notchedOutlineTextField,
                            }}
                            placeholder={`Digite o nome do tipo atendimento`}
                            value={agendamentoTipoSelected?.descricao}
                            onChange={this.handleChange}
                        />
                    </div>
                    {unidadeLogada?.referenciaAzulControle && <div className={classes.contentStatus}>
                        <div className={classes.titleRenderHeader}>Financeiro</div>
                        <Switch
                            id='cfg-cco-swt-fin'
                            checked={agendamentoTipoSelected?.geraFinanceiro}
                            color="primary"
                            onClick={() => this.handleChangeSwitch('geraFinanceiro')}
                        />
                    </div>}
                    <div className={classes.contentStatus}>
                        <div className={classes.titleRenderHeader}>Destaque</div>
                        <Switch
                            id='cfg-cco-swt-des'
                            checked={agendamentoTipoSelected?.destaque}
                            color="primary"
                            onClick={() => this.handleChangeSwitch('destaque')}
                        />
                    </div>
                    {agendamentoTipoSelected?.id && (
                        <div className={classes.contentStatus}>
                            <div className={classes.titleRenderHeader}>Status</div>
                            <Switch
                                id='cfg-cco-swt-sta'
                                checked={agendamentoTipoSelected?.ativo}
                                color="primary"
                                onClick={() => this.handleChangeSwitch('ativo')}
                            />
                        </div>
                    )}
                </div>
                <div className={utilizaDuracaoProcedimentosTipoConsulta ? classes.rowHeader : classes.rowHeaderAdaptado}>
                    <div className={classes.contentFieldHeader}>
                        <div className={classes.titleRenderHeader}> Tuss 52 - Tipos de consulta </div>
                        <TextFieldSearch
                            id='cfg-cco-sel-t52'
                            name='tuss52TerminologiaTipoConsulta'
                            placeholder='Selecione'
                            classNotched={classes.notchedOutline}
                            className={classes.renderHeaderSelect}
                            loadOptions={this.loadAllTuss52}
                            withPaginate
                            value={agendamentoTipoSelected?.tuss52TerminologiaTipoConsulta}
                            onChange={e => this.handleChangeTipoConsulta(e, "tuss52TerminologiaTipoConsulta")}
                            getOptionLabel={option => option.codigoTermoDescricao}
                            debounceTimeout={300}
                            additional={{
                                page: 0,
                            }}
                        />
                    </div>
                    <div className={classes.contentFieldHeader}>
                        <div className={classes.titleRenderHeader}> Tuss 22 - Procedimentos e eventos em saúde </div>
                        <TextFieldSearch
                            id='cfg-cco-sel-t22'
                            name='tuss22ProcedimentoEventoSaude'
                            placeholder='Selecione'
                            classNotched={classes.notchedOutline}
                            className={classes.renderHeaderSelect}
                            loadOptions={this.loadAllTuss22}
                            withPaginate
                            value={agendamentoTipoSelected.tuss22ProcedimentoEventoSaude}
                            onChange={e => this.handleChangeTipoConsulta(e, "tuss22ProcedimentoEventoSaude")}
                            getOptionLabel={option => option.codigoTermoDescricao}
                            debounceTimeout={300}
                            additional={{
                                page: 0,
                            }}
                        />
                    </div>
                    {utilizaDuracaoProcedimentosTipoConsulta &&
                        <div>
                            <div className={classes.titleRenderHeader}>Duração: </div>
                            <InputForm
                                id='cfg-cco-inp-dur'
                                type={'number'}
                                value={agendamentoTipoSelected?.duracaoTipoConsulta}
                                onChange={(e) => this.handleChangeTipoConsulta(e.target.value, 'duracaoTipoConsulta')}
                                className={classes.inputContainer}
                                classes={{ input: classes.input }}
                            />
                        </div>}
                </div>
            </>
        )
    };

    changeTabSelectedModal = async(tabSelected) => {
        if (tabSelected === 0) {
            this.setState(
                {
                    convenios: [],
                    pageNumberModal: 0,
                    lastModal: false,
                    tabSelectedModal: 0,
                    propsTabsModal: { valueSearch: "" },
                },
                () => this.loadConvenios()
            );
        } else if (tabSelected === 1) {
            this.setState(
                {
                    profissionais: [],
                    pageNumberProfissionais: 0,
                    lastProfissionais: false,
                    tabSelectedModal: 1,
                    propsTabsModal: { valueSearch: "" },
                },
                () => this.loadProfissionais()
            );
        }
    };

    handleChangeSwitch = (field) => {
         const { agendamentoTipoSelected } = this.state;

        this.setState({
            agendamentoTipoSelected: {
                ...agendamentoTipoSelected,
                [field]: !agendamentoTipoSelected[field]
            }
        });
    }
    
    render() {
        const {isLoading, lastPage, agendamentoTipoSelected, loadingSave, agendamentoTipo, search, propsTabsModal, ordenarTabela} = this.state;
        const {classes, agendamentoTipoStore, modalConfiguracoesStore, unidadeStore} = this.props;
        
        return (
            <>
                <Grid className={classes.content}>
                    <PageTitle title={pageConfiguracoes("Tipos de atendimento")}/>
                    <HeaderConfiguracoesButtonNovo
                        idPrefix='cfg-cco'
                        title="Tipos de atendimento"
                        labelButton="Novo tipo de atendimento"
                        handleClickNovo={this.createAgendamentoTipo}
                        search={{
                            handleChange: this.onChangeSearch,
                            value: search,
                            onKeypress: this.onKeypressSearch,
                            handleClickClear: this.handleClickClear,
                            onClickButtonSearch: this.handleClickSearch
                        }}
                    />
                    <div className={classes.contentList}>
                        <ContentConfiguracoes
                            setAuditoriaTela={this.setAuditoriaTela}
                        >
                            <div className={classes.table}>
                                <Scroll
                                    hasMore={!isLoading && !lastPage}
                                    pageStart={0}
                                    initialLoad={false}
                                    loadMore={() => this.loadAgendamentoTipo()}
                                >
                                    {
                                        agendamentoTipo.length > 0 && <Table
                                            dados={agendamentoTipo}
                                            columns={columnsConfiguracoes({
                                                isDescricao: true,
                                                headerNome: "Nome do tipo atendimento",
                                                idPrefix: 'cfg-cco',
                                                functions: {
                                                    handleEditar: this.editAgendamentoTipoById,
                                                    handleDuplicar: this.handleDuplicar,
                                                    handleDesativar: this.handleInativar,
                                                    handleAtivar: this.handleAtivar,
                                                },
                                            })}
                                            clickable={true}
                                            handleClick={this.handleClickRow}
                                            comOrdenacao
                                            ordenarTabela={ordenarTabela}
                                            handleClickOrdenar={(value) => this.handleClickOrdenar(value)} 
                                        />
                                    }
                                </Scroll>
                            </div>
                        </ContentConfiguracoes>
                            <Button
                                id='cfg-cco-btn-nov'
                                shadow
                                shape='circle'
                                bgColor='#26ACA9'
                                onClick={this.createAgendamentoTipo}
                                className={classes.buttonCriar}
                            >
                                <AddIcon/>
                            </Button>
                    </div>
                    {
                        modalConfiguracoesStore.showModal &&
                        <ModalConfiguracoesTabs
                            itemSelecionado={agendamentoTipoSelected}
                            title={"consulta"}
                            renderHeader={this.renderHeader}
                            classes={{
                                content: agendamentoTipoSelected?.id ? classes.contentModalEdit : classes.contentModal
                            }}
                            onClose={this.onCloseModalTipoAgendamento}
                            handleSave={this.save}
                            loadingModal={this.state.loadingModal}
                            propsTabs={{
                                ...propsTabsModal,
                                options: ["Convênios", "Profissional de Saúde"],
                                tabSelected: this.state.tabSelectedModal || 0,
                                changeTabSelected: this.changeTabSelectedModal,
                                handleClickSearch: this.handleClickSearchModal,
                                handleClickClear: this.handleClickClearModal,
                                onChangeSearch: this.onChangeSearchModal,
                                onKeypressSearch: this.onKeypressSearchModal,
                            }}
                            propsPopperCustom={{
                                handleEditar: this.handleEditar,
                                handleDuplicar: this.handleDuplicar,
                                handleDesativar: this.handleInativar,
                                handleAtivar: this.handleAtivar,
                            }}
                            propsTabsAuditoria={{
                                tabSelected: this.state.propsTabsAuditoria.tabSelected,
                                changeTabAuditoriaSelected: this.changeTabModalAuditoriaSelected,
                            }}
                            loadingSave={loadingSave}
                        >
                            {(this.state.tabSelectedModal || 0) === 0 ? (
                                <ConvenioList
                                    listaModal={this.state.convenios}
                                    handleChangeCheckbox={this.handleChangeCheckbox}
                                    handleChange={this.handleChange}
                                    loadMore={this.loadMoreModal}
                                    lastScroll={this.state.lastModal}
                                    loadingModal={this.state.loadingModal}
                                    classes={{ content: classes.contentConvenioList }}
                                    handleChangeMotivoCancelamento={this.handleChangeMotivoCancelamento}
                                />
                            ) : (
                                <ProfissionalSaudeValorList
                                    listaModal={this.state.profissionais}
                                    handleChangeCheckbox={this.handleChangeCheckboxProfissional}
                                    handleChange={this.handleChangeProfissionalValor}
                                    loadMore={this.loadMoreProfissionais}
                                    lastScroll={this.state.lastProfissionais}
                                    loadingModal={this.state.loadingProfissionais}
                                    classes={{ content: classes.contentConvenioList }}
                                />
                            )}
                        </ModalConfiguracoesTabs>
                    }
                    <ModalConfirmacao
                        open={this.state.openAlertAgendamentoTipo}
                        classes={{
                            paperAlert: classes.paperAlert
                        }}
                        icon={<WarningIcon />}
                        color={"yellow"}
                        title={"Já foi criado um tipo de atendimento com esse nome"}
                        buttons={{
                            labelPrimaryButton: "Salvar assim mesmo",
                            handlePrimaryButton: () => this.saveAgendamentoTipoComMesmoNome(),
                            labelSecondButton: "Voltar e alterar nome",
                            handleSecondButton: () => this.voltarMudarNome(),
                            disabledPrimaryButton: loadingSave,
                            disabledSecondButton: loadingSave,
                            idPrimaryButton: 'cfg-cco-btn-slv',
                            idSecondButton: 'cfg-cco-btn-vol',
                        }}
                    />
                </Grid>

                
                    <Button
                        id='cfg-cco-btn-nov'
                        shadow
                        shape='circle'
                        bgColor='#26ACA9'
                        onClick={this.createAgendamentoTipo}
                        className={classes.buttonCriar}
                        
                    >
                        <Add/>
                    </Button>
               

                <Notification
                    close={this.handleClose}
                    isOpen={agendamentoTipoStore.notification.isOpen}
                    variant={agendamentoTipoStore.notification.variant}
                    message={agendamentoTipoStore.notification.message}
                />
            </>
        );
    }
}

const style = theme => ({
    header: {
        width: '100%',
        height: '80px',
        background: '#fff',
        display: 'flex',
        justifyContent: 'space-between'
    },
    wrapperHeader:{
        display: 'flex',
        zIndex: 3,
    },
    content: {
        background: "#F5F5F5",
        "& #buttonCircle": {
            boxShadow: 'none',
            background: "#fff",
            color: "#5F6368",
        },
    },
    contentModal: {
        height: "calc(100% - 238px) !important",
    },
    contentModalEdit: {
        height: "calc(100% - 278px)",
    },
    contentList: {
        display: 'flex',
        flexDirection: 'column',
        color: '#fff',
        fontWeight: 600,
        alignItems: 'center',
        padding: "24px 24px 0",
        gap: '16px',
        height: "calc(100% - 104px)",   
    },
    table: {
        "&>div": {
            height: 'calc(100vh - 240px)',
            overflow: 'auto',
        },
        "& thead th": {
            textAlign: "left",
            top: 0,
            position: "sticky",
            zIndex: 1,
        },
    },
    notFoundContainer: {
        width: '100%',
        display: "flex",
        justifyContent: "center",
    },
    buttonCriar: {
        position: 'absolute',
        bottom: 88,
        right: 37,
        zIndex: 100
    },
    paperAlert: {
        maxWidth: "373px",
    },
    rowHeader: {
        gap: "8px",
        marginTop: "8px",
        display: 'grid',
        gridTemplateColumns: '33% 50% 10%',
        alignContent: 'center'
    },
    rowHeaderAdaptado: {
        gap: "8px",
        marginTop: "8px",
        display: 'grid',
        gridTemplateColumns: '50% 50% ',
        alignContent: 'center'
    },
    titleRenderHeader: {
        color: "#868686",
        fontSize: "12px",
    },
    profile: {
        textAlign: 'end',
        paddingRight: 16,
        zIndex: 3,
    },
    titleHeader: {
        fontSize: "25px",
        fontWeight: "bold",
        color: theme.palette.primary.main,
        marginLeft: "10px"
    },
    wrapperTable:{
        width: '100%',
        height: 'calc(100vh - 128px)',
        overflow: 'auto'
    },
    botaoOrganizar: {
        color: 'white',
        width: 20,
        height: 20,
        marginLeft: 10,
    },
    selectStatus:{
        width: 200,
    },
    wrapperButtonAdd:{
        paddingRight: '3rem'
    },
    buttonNovo:{
        width: 200,
        height: 40,
        borderRadius: 87,
        boxShadow: 'none',
        background: '#F9BE73',
        color: '#fff',
        textTransform: 'capitalize',
        padding: '0 14px',
        marginLeft: 24,
        minWidth: 152,
        "@media (max-width: 1600px)": {
            width: 40,
            minWidth: 40,
            borderRadius: '100%',
        }
    },
    labelButtonNovo: {
        marginLeft: '5px',
        whiteSpace: 'nowrap',
        "@media (max-width: 1600px)": {
            display: 'none',
        }
    },
    colorIconOrdenacao: {
        filter: 'brightness(0.4)',
    },
    contentConvenioList: {
        height: 'calc(100% - 70px)',
    },
    contentFieldHeader: {
        width: "100%",
    },
    notchedOutline: {
        border: 'none',
    },
    renderHeaderSelect: {
        "&>div": {
            fontFamily: 'Poppins',
            fontSize: '14px',
            fontWeight: 600,
            color: '#868686',
            "&>div": {
                height: '38px',
                background: '#f2f2f2',
                borderRadius: '8px',
                border: '0.5px solid rgba(220, 220, 220, 0.2)',
            },
        },
        "& p": {
            color: "#868686",
            fontWeight: 600,
        },
    },
    rowNome: {
        marginBottom: "4px",
        display: "flex",
        gap: "4px",
    },
    notchedOutlineTextField: {
        "& fieldset": {
            border: "none",
        },
    },
    contentNome: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
    },
    textField: {
        height: "40px",
        width: "100%",
        "& input": {
          height: "23px",
          background: "#F2F2F2",
          border: "0.5px solid rgba(220, 220, 220, 0.2)",
          borderRadius: "8px",
          fontFamily: "Poppins",
          fontSize: "14px",
          fontWeight: 600,
          color: '#868686',
        },
        "& ::placeholder": {
          color: '#000'
        },
    },
    inputContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#F2F2F2",
        width: "60px",
        height: "40px",
        color: "#505050",
        marginBottom: "8px",
        borderRadius: "8px",
        "&>div>input": {
            paddingRight: "0px",
        },
        border: 'none'
    },
    input: {
        color: "#505050",
        background: "#F2F2F2",
        border: "0 !important",
        borderRadius: "8px",
        height: "30px",
        boxSizing: "border-box",
        fontSize: "14px"
    },
});

export default withStyles(style)(ConfiguracaoConsulta);
